export default {
  namespaced: true,
  state: {
    answeredQuestionsCount: 0,
    isDataReady: false,
    isDetailViewActive: false,
    hoveredSpecs: [],
    items: [],
    sortedItems: [],
    questions: [],
    scrollBreakpointMax: 950,
    isSingleProductViewActive: false,
    specs: {},
    variantIndex: 1,
    isQuickViewActive: false,
  },

  getters: {
    answeredQuestionsCount: state => state.answeredQuestionsCount,
    isDataReady: state => state.isDataReady,
    isDetailViewActive: state => state.isDetailViewActive,
    sortedItems: state => state.sortedItems,
    questions: state => state.questions,
    scrollBreakpointMax: state => state.scrollBreakpointMax,
    isSingleProductViewActive: state => state.isSingleProductViewActive,
    specs: state => state.specs,
    variantIndex: state => state.variantIndex,
    hoveredSpecs: state => state.hoveredSpecs,
    isQuickViewActive: state => state.isQuickViewActive,
  },

  mutations: {
    setState(state, payload) {
      for (let key in payload) state[key] = payload[key]
    },

    setSpec(state, payload) {
      state.specs[payload.category] = payload.value
    },

    setVariantIndex(state, payload) {
      state.variantIndex = payload
    },

    setDetailViewActive(state, payload) {
      state.isDetailViewActive = payload
    },

    setSingleProductViewActive(state, payload) {
      state.isSingleProductViewActive = payload
    },

    setAnsweredQuestionsCount(state, payload) {
      state.answeredQuestionsCount = payload
    },

    addHoverSpecs(state, payload) {
      state.hoveredSpecs.push(payload)
    },

    setDataReady(state) {
      state.isDataReady = true
    },

    clearHoverSpecs(state) {
      state.hoveredSpecs = []
    },

    setQuickViewActive(state, payload) {
      state.isQuickViewActive = payload
    },

    setSortedItems(state, payload) {
      state.sortedItems = payload
    },
  },

  actions: {
    sortItems({ state, commit }) {
      const sortedItems = JSON.parse(JSON.stringify(state.items))
      sortedItems.sort((a, b) => b.relevance - a.relevance)
      commit('setSortedItems', sortedItems)
    },

    calculateRelevance({ state }) {
      state.items.forEach(item => {
        item.relevance = 0
        for (let spec in state.specs) {
          if (state.specs.hasOwnProperty(spec)) {
            const specValue = state.specs[spec]
            const relevance = item.specs[spec][specValue]
            if (relevance != undefined) {
              item.relevance += relevance
            }
          }
        }
      })
    },
  },
}
